import accruedExpenses from './accrued-expenses';
import accruedRevenues from './accrued-revenues';
import asset from './asset';
import assetAllowanceClaim from './asset-allowance-claim';
import assetDepreciationSchedule from './asset-depreciation-schedule';
import assetJurisdictionCapitalAllowanceSchedule from './asset-jurisdiction-capital-allowance-schedule';
import deferredRevenues from './deferred-revenues';
import dimensions from './dimensions';
import fxCurrencies from './fx-currencies';
import fxCustomerRates from './fx-customer-rates';
import generalLedgerAccounts from './general-ledger-accounts';
import generalLedgers from './general-ledgers';
import journalEntries from './journal-entries';
import journalEntryBatches from './journal-entry-batches';
import prepaidExpenses from './prepaid-expenses';
import recurringJournalEntries from './recurring-journal-entries';
import recurringJournalEntryBatches from './recurring-journal-entry-batches';
import trialBalances from './trial-balances';

let messages = Object.assign({}, accruedExpenses, accruedRevenues, asset, assetAllowanceClaim, assetDepreciationSchedule, assetJurisdictionCapitalAllowanceSchedule, deferredRevenues, dimensions, fxCurrencies, fxCustomerRates, generalLedgerAccounts, generalLedgers, journalEntries, journalEntryBatches, prepaidExpenses, recurringJournalEntries, recurringJournalEntryBatches, trialBalances);

export default messages;
